import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { BaseService } from 'src/app/system-common/services/base.service';
import { Observable } from 'rxjs';

@Injectable()
export class ContestAndIncentiveDetailsServiceHandler extends BaseService {
  public contestIncentiveFacets: any;

  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService, 'EVALUATION');
  }

  public init(modelNameList: string[]) {
    console.log('init cotest service');

    return this.getContestAndIncentiveDetails(0, modelNameList);
  }

  public load(id: any, modelNameList: string[]) {
    console.log('load cotest service');
    return this.getContestAndIncentiveDetails(id, modelNameList);
  }

  public process(id: any, modelNameList: string[]) {
    console.log('process cotest service');
    return null;
  }

  public find(searchName, executeSearch?: boolean, searchCriteriaData?: any) {
    return this.getSearchList(searchName, executeSearch, searchCriteriaData);
  }

  public findForLanding(executeSearch?: boolean, searchCriteriaData?: any) {
    console.log('findForLanding cotest service');
    return null;
  }

  public clear() {
    super.clear();
  }

  private getContestAndIncentiveDetails(id: number, modelNameList: any) {
    let path = this.getURLValue('EVALUATION');
    console.log('path*********', path);

    return this.httpGet(`${path}?id=${id}`);
  }

  getDynamicFacet(id: any): Observable<Object> {
    let body = {
      id: id,
    };
    let path = this.getURLValue('EVALUATION');
    console.log('path evaluatiom', path);
    console.log('this.httpPost(`${path}/getDynamicFacet`, body)', this.httpPost(`${path}/getDynamicFacet`, body));

    return this.httpPost(`${path}/getDynamicFacet`, body);
  }

  protected postLoadCompanyFacets() {}

  getEvaluationDetails(evaluationId: any): Observable<Object> {
    let path = this.getURLValue('EVALUATION');
    return this.httpGet(`${path}?evaluationId=${evaluationId}`);
  }

  getEvaluationSubDetails(evaluationdtlId: any): Observable<Object> {
    let path = 'api/evaluationSubDetails';
    return this.httpGet(`${path}?evaluationdtlId=${evaluationdtlId}`);
  }
}
